import { collectPanelIds, treeContainsPanel, treeContainsSubtree } from './layoutTree.js';

export function checkPanelDropInvariants(beforeRoot, afterRoot, panelId) {
    if (!panelId) return { ok: false, reason: 'missing-panel-id' };
    if (!treeContainsPanel(afterRoot, panelId)) {
        return { ok: false, reason: 'panel-not-found-after-drop' };
    }
    const beforeIds = collectPanelIds(beforeRoot);
    const afterIds = collectPanelIds(afterRoot);
    const lost = beforeIds.filter((id) => !afterIds.includes(id));
    if (lost.length) {
        return {
            ok: false,
            reason: 'panels-lost',
            lostPanelIds: lost,
        };
    }
    return { ok: true };
}

export function checkGroupDropInvariants(afterRoot, subtree) {
    if (!subtree) return { ok: false, reason: 'missing-subtree' };
    if (!treeContainsSubtree(afterRoot, subtree)) {
        return { ok: false, reason: 'subtree-not-found-after-drop' };
    }
    return { ok: true };
}

